import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=397b078d&scoped=true&"
import script from "./AlertForm.vue?vue&type=script&lang=js&"
export * from "./AlertForm.vue?vue&type=script&lang=js&"
import style0 from "./AlertForm.vue?vue&type=style&index=0&id=397b078d&prod&lang=css&"
import style1 from "./AlertForm.vue?vue&type=style&index=1&id=397b078d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b078d",
  null
  
)

export default component.exports